import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from 'react';
interface UseNavigationHoverProps {
  openDelay?: number;
  switchDelay?: number;
  exitDelay?: number;
}
export const useNavigationHover = t0 => {
  const $ = _c(26);
  const {
    openDelay: t1,
    switchDelay: t2,
    exitDelay: t3
  } = t0;
  const openDelay = t1 === undefined ? 300 : t1;
  const switchDelay = t2 === undefined ? 300 : t2;
  const exitDelay = t3 === undefined ? 500 : t3;
  const [activeItem, setActiveItem] = useState("");
  const [isInViewport, setIsInViewport] = useState(false);
  const switchTimeoutRef = useRef(null);
  const exitTimeoutRef = useRef(null);
  const checkExitTimeoutRef = useRef(null);
  const openTimeoutRef = useRef(null);
  const isInContentRef = useRef(false);
  const isInViewportRef = useRef(false);
  const isInTriggerRef = useRef(false);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (switchTimeoutRef.current) {
        clearTimeout(switchTimeoutRef.current);
        switchTimeoutRef.current = null;
      }
      if (exitTimeoutRef.current) {
        clearTimeout(exitTimeoutRef.current);
        exitTimeoutRef.current = null;
      }
      if (checkExitTimeoutRef.current) {
        clearTimeout(checkExitTimeoutRef.current);
        checkExitTimeoutRef.current = null;
      }
      if (openTimeoutRef.current) {
        clearTimeout(openTimeoutRef.current);
        openTimeoutRef.current = null;
      }
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const clearTimeouts = t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      clearTimeouts();
      setActiveItem("");
      setIsInViewport(false);
      isInContentRef.current = false;
      isInViewportRef.current = false;
      isInTriggerRef.current = false;
    };
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const resetNavigation = t5;
  let t6;
  if ($[2] !== exitDelay || $[3] !== switchDelay) {
    t6 = () => {
      if (checkExitTimeoutRef.current) {
        clearTimeout(checkExitTimeoutRef.current);
      }
      checkExitTimeoutRef.current = setTimeout(() => {
        if (!isInTriggerRef.current && !isInContentRef.current) {
          exitTimeoutRef.current = setTimeout(() => {
            setActiveItem("");
            setIsInViewport(false);
          }, exitDelay);
        }
      }, switchDelay);
    };
    $[2] = exitDelay;
    $[3] = switchDelay;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const checkShouldExit = t6;
  let t7;
  if ($[5] !== activeItem || $[6] !== openDelay || $[7] !== switchDelay) {
    t7 = itemTitle => {
      clearTimeouts();
      isInTriggerRef.current = true;
      if (!activeItem) {
        openTimeoutRef.current = setTimeout(() => {
          setActiveItem(itemTitle);
          setIsInViewport(true);
          isInViewportRef.current = true;
        }, openDelay);
        return;
      }
      if (activeItem === itemTitle) {
        setIsInViewport(true);
        isInViewportRef.current = true;
        return;
      }
      switchTimeoutRef.current = setTimeout(() => {
        setActiveItem(itemTitle);
        setIsInViewport(true);
        isInViewportRef.current = true;
      }, switchDelay);
    };
    $[5] = activeItem;
    $[6] = openDelay;
    $[7] = switchDelay;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleTriggerEnter = t7;
  let t8;
  if ($[9] !== checkShouldExit) {
    t8 = e => {
      if (e?.pointerType !== "mouse") {
        return;
      }
      isInTriggerRef.current = false;
      if (openTimeoutRef.current) {
        clearTimeout(openTimeoutRef.current);
        openTimeoutRef.current = null;
      }
      if (switchTimeoutRef.current) {
        clearTimeout(switchTimeoutRef.current);
        switchTimeoutRef.current = null;
      }
      checkShouldExit();
    };
    $[9] = checkShouldExit;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleTriggerLeave = t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      clearTimeouts();
      isInContentRef.current = true;
      setIsInViewport(true);
      isInViewportRef.current = true;
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const handleContentEnter = t9;
  let t10;
  if ($[12] !== checkShouldExit) {
    t10 = () => {
      isInContentRef.current = false;
      checkShouldExit();
    };
    $[12] = checkShouldExit;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const handleContentLeave = t10;
  let t11;
  if ($[14] !== checkShouldExit) {
    t11 = () => {
      clearTimeouts();
      isInViewportRef.current = true;
      setIsInViewport(true);
      checkShouldExit();
    };
    $[14] = checkShouldExit;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const handleViewportEnter = t11;
  let t12;
  if ($[16] !== exitDelay) {
    t12 = () => {
      isInViewportRef.current = false;
      exitTimeoutRef.current = setTimeout(() => {
        setActiveItem("");
        setIsInViewport(false);
      }, exitDelay);
    };
    $[16] = exitDelay;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const handleViewportLeave = t12;
  let t13;
  if ($[18] !== activeItem || $[19] !== handleContentLeave || $[20] !== handleTriggerEnter || $[21] !== handleTriggerLeave || $[22] !== handleViewportEnter || $[23] !== handleViewportLeave || $[24] !== isInViewport) {
    t13 = {
      resetNavigation,
      activeItem,
      setActiveItem,
      isInViewport,
      handleTriggerEnter,
      handleTriggerLeave,
      handleContentEnter,
      handleContentLeave,
      handleViewportEnter,
      handleViewportLeave
    };
    $[18] = activeItem;
    $[19] = handleContentLeave;
    $[20] = handleTriggerEnter;
    $[21] = handleTriggerLeave;
    $[22] = handleViewportEnter;
    $[23] = handleViewportLeave;
    $[24] = isInViewport;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};